import { useState } from 'react';
import { FaBars, FaShoppingCart, FaTimes } from 'react-icons/fa';
import { useCart } from '../../context/CartContext';
import './Header.css';

const Header = () => {
  const { openCart, getCartCount } = useCart();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const menuItems = [
    { id: 'home', label: 'गृहपृष्ठ' },
    { id: 'products', label: 'सामग्रीहरू' },
    { id: 'offers', label: 'प्रस्तावहरू' },
    { id: 'delivery', label: 'वितरण' },
    { id: 'contact', label: 'सम्पर्क' }
  ];

  return (
    <header className="header">
      <div className="container header-content">
        {/* Logo Section */}
        <div className="logo" onClick={() => scrollToSection('home')}>
          <div className="logo-icon-container">
            <span className="logo-emoji">🥔</span>
            <span className="logo-emoji">🧅</span>
          </div>
          <div className="logo-text">
            <h1>उग्रचण्डी आलु प्याज भण्डार  </h1>
            <p className="logo-tagline">ताजा सब्जी, तपाईंको ढोकामा</p>
          </div>
        </div>

        {/* Desktop Navigation */}
        <nav className="desktop-nav">
          <ul>
            {menuItems.map(item => (
              <li key={item.id}>
                <button
                  onClick={() => scrollToSection(item.id)}
                  className="nav-link"
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        {/* Cart and Mobile Menu Toggle */}
        <div className="header-actions">
          <div className="cart-icon" onClick={openCart}>
            <FaShoppingCart className="cart-icon-svg" />
            <span className="cart-count">{getCartCount()}</span>
            <span className="cart-text">कार्ट</span>
          </div>

          <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
            {mobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="mobile-nav">
            <ul>
              {menuItems.map(item => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollToSection(item.id)}
                    className="mobile-nav-link"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
              <li className="mobile-cart-item">
                <button onClick={openCart} className="mobile-cart-btn">
                  <FaShoppingCart />
                  <span>कार्ट ({getCartCount()})</span>
                </button>
              </li>
            </ul>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;